import React from "react";
import { useLocation } from "react-router-dom";

function OrderDetails() {
const location = useLocation();
const order = location.state || {};


//   const order = {
//     client: "Ravi Kumar",
//     contact: "9876543210",
//     address: "Delhi, India",
//     services: [
//       { name: "Cleaning", price: 30, time: "30 min" },
//       { name: "Dusting", price: 20, time: "15 min" }
//     ],
//     payment: {
//       subtotal: 500,
//       gst: 90,
//       total: 590
//     }
//   };

  

  return (
<div className="container-fluid mt-4 mb-4">

 
  <div
    className="p-4 rounded-4"
    style={{
      backgroundColor: "var(--black)",
      border: "1px solid #2d3748"
    }}
  >

    {/* 🔥 HEADER */}
    <div className="d-flex justify-content-between mb-4">
      <div>
        <h4 className="text-white mb-1">
          Sweepyo
        </h4>
        <small className="text-secondary">#ORD-0001</small>
      </div>

      <div className="text-end text-white">
        <div><strong>Date:</strong> 15/04/2026</div>
        <div><strong>Due Date:</strong> 20/04/2026</div>
      </div>
    </div>

    {/* 🔥 FROM / TO */}
    <div className="row mb-4">

      <div className="col-md-6">
        <div className="p-3 rounded-3 border border-secondary h-100">
          <h6 className="text-white mb-3">From:</h6>
          <div className="text-white">Your Company</div>
          <div className="text-secondary">Delhi, India</div>
          <div className="text-secondary">+91 9999999999</div>
          <div className="text-secondary">company@gmail.com</div>
        </div>
      </div>

      <div className="col-md-6">
        <div className="p-3 rounded-3 border border-secondary h-100">
          <h6 className="text-white mb-3">To:</h6>
          <div className="text-white">{order.client}</div>
          <div className="text-secondary">{order.address}</div>
          <div className="text-secondary">{order.contact}</div>
        </div>
      </div>

    </div>

    {/* 🔥 TABLE */}
    <div className="table-responsive mb-4">
      <table className="table text-white mb-0 table-hover">

        <thead>
          <tr style={{ backgroundColor: "var(--black2)" }}>
            <th className="py-3" style={{ backgroundColor: "var(--black2)", color: "#fff" }}>#</th>
            <th className="py-3" style={{ backgroundColor: "var(--black2)", color: "#fff" }}>Name</th>
            <th className="py-3" style={{ backgroundColor: "var(--black2)", color: "#fff" }}>Description</th>
            <th className="py-3" style={{ backgroundColor: "var(--black2)", color: "#fff" }}>QTY</th>
            <th className="py-3" style={{ backgroundColor: "var(--black2)", color: "#fff" }}>Price</th>
            <th className="py-3" style={{ backgroundColor: "var(--black2)", color: "#fff" }}>Amount</th>
          </tr>
        </thead>

        <tbody>
          {order.services.map((srv, i) => (
            <tr key={i}>
              <td style={{ backgroundColor: "var(--black)", color: "#fff" }}>{i + 1}</td>
              <td style={{ backgroundColor: "var(--black)", color: "#fff" }} >{srv.name}</td>
              <td style={{ backgroundColor: "var(--black)", color: "#fff" }}> {srv.name} Service</td>
              <td style={{ backgroundColor: "var(--black)", color: "#fff" }}>1</td>
              <td style={{ backgroundColor: "var(--black)", color: "#fff" }}>₹ {srv.price}</td>
              <td style={{ backgroundColor: "var(--black)", color: "#fff" }}>₹ {srv.price}</td>
            </tr>
          ))}
        </tbody>

      </table>
    </div>

    {/* 🔥 TOTALS */}
    <div className="row justify-content-end mb-4">

      <div className="col-md-4">
        <div className="text-white">

          <div className="d-flex justify-content-between mb-2">
            <span>Sub Total:</span>
            <span>₹ {order.payment.subtotal}</span>
          </div>

          <div className="d-flex justify-content-between mb-2 text-success">
            <span>Discount:</span>
            <span>₹ 0</span>
          </div>

          <div className="d-flex justify-content-between mb-2">
            <span>Tax:</span>
            <span>₹ {order.payment.gst}</span>
          </div>

          <hr style={{ borderColor: "#334155" }} />

          <div className="d-flex justify-content-between fw-bold">
            <span>Grand Total:</span>
            <span>₹ {order.payment.total}</span>
          </div>

        </div>
      </div>

    </div>

    {/* 🔥 NOTE + DOWNLOAD BUTTON */}
    <div className="d-flex justify-content-between align-items-center">

      <div className="text-secondary">
        <strong>Notes:</strong> Thank you for your business.
      </div>

      <button className="btn btn-primary">
        Download
      </button>

    </div>

  </div>

</div>
  );
}

export default OrderDetails;